import { AdminHeader } from '../../components/AdminHeader';

import { CtaBlock } from '../../components/CtaBlock';

const AdminPanel = () => {
    let helpItems = [
		{
            title: 'Videos and Duo - Everything you need to know',
            text: (
                <div>
                    <div style={{ marginTop: '20px' }}></div>

                    <iframe
                        width="560"
                        height="315"
                        src={
                            'https://www.youtube.com/embed/dbPaPjIvEpQ?si=DpvOnD8A5fU4rZFj'
                        }
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
            ),
        },
        {
            title: 'How to Create an Unterrichtkonzept Article',
            text: (
                <div>
                    <div style={{ marginTop: '20px' }}></div>

                    <iframe
                        width="560"
                        height="315"
                        src={
                            'https://www.youtube.com/embed/f8f9KN7rgyM?si=QI0NUlFKhYrt7yM3'
                        }
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
            ),
        },
        {
            title: 'How to upload an Image',
            text: (
                <div>
                    <div style={{ marginTop: '20px' }}></div>

                    <iframe
                        width="560"
                        height="315"
                        src={
                            'https://www.youtube.com/embed/u07EGFCkpas?si=AvtsMBIikNxEnxBi'
                        }
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
            ),
        },
    ];

    return (
        <div className="homepage-desktop" data-tokens-mode="desktop">
            <AdminHeader
                className="design-component-instance-node-7"
                style="desktop"
                s
                logoDimensions={{
                    height: 64 * 1.8 + 'px',
                    width: 104 * 1.8 + 'px',
                }}
            />

            <div className="content-wrapper-3">
                <div style={{ height: '100vh' }}>
                    {helpItems.map((helpItem, i) => {
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <CtaBlock
                                    useHomepageCtaBlockStyleButton={true}
                                    buttonTextLink={null}
                                    className="design-component-instance-node-7"
                                    stateProp="default"
                                    style="default"
                                    text={helpItem.text}
                                    title={helpItem.title}
                                    showLink={true}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default AdminPanel;
